import { render, staticRenderFns } from "./Student.vue?vue&type=template&id=11b6ff3b&scoped=true"
import script from "./Student.vue?vue&type=script&lang=js"
export * from "./Student.vue?vue&type=script&lang=js"
import style0 from "./Student.vue?vue&type=style&index=0&id=11b6ff3b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b6ff3b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_business_lcPT/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('11b6ff3b')) {
      api.createRecord('11b6ff3b', component.options)
    } else {
      api.reload('11b6ff3b', component.options)
    }
    module.hot.accept("./Student.vue?vue&type=template&id=11b6ff3b&scoped=true", function () {
      api.rerender('11b6ff3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/infoDetail/Student.vue"
export default component.exports